import { render, staticRenderFns } from "./GlobalNotification.vue?vue&type=template&id=cfdf2daa&scoped=true&"
import script from "./GlobalNotification.vue?vue&type=script&lang=js&"
export * from "./GlobalNotification.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotification.vue?vue&type=style&index=0&id=cfdf2daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdf2daa",
  null
  
)

export default component.exports